import Plyr from 'plyr';

/**
 * Creates Plyr video elements
 */
export function registerPlyr(): void {
    // Inline Plyr-spelare
    const inlinePlayers = document.querySelectorAll('.plyr-inline');
    inlinePlayers.forEach((p) => {
        const player = new Plyr(p as HTMLElement, {
            muted: true,
            hideControls: true,
            clickToPlay: false,
            loop: {
                active: true,
            },
            volume: 0,
            controls: [],
        });

        console.log('Inline player initialized:', player);
        console.log("player.autoplay: ", player.autoplay);
        console.log("player.muted: ", player.muted);
        console.log("player.volume: ", player.volume);

        setTimeout(() => {
            player.play();
        }, 1000);
    });

    // Anpassad Plyr-spelare
    const customPlayers = document.querySelectorAll('.plyr-inline-campaign');
    customPlayers.forEach((p) => {
        const player = new Plyr(p as HTMLElement, {
            autoplay: false,
            muted: false,
            hideControls: false,
            clickToPlay: true,
            controls: [
                'play', // Spela/pausa
                'progress', // Progress bar
                'current-time', // Nuvarande tid
                'mute', // Stäng av ljud
                'volume', // Volymkontroll
                'settings', // Inställningar som kvalitet
                'fullscreen', // Fullskärm
            ],
        });

        console.log('plyr-inline-campaign:', player);
    });

    console.log(`Registered ${inlinePlayers.length} inline players.`);
    console.log(`Registered ${customPlayers.length} custom players.`);
}
